import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IConfiguration } from 'next-common';

interface ConfigState {
  configuration: IConfiguration;
}

const initialState: ConfigState = {
  configuration: {},
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setConfiguration: (state, action: PayloadAction<IConfiguration>) => {
      state.configuration = action.payload;
    },
  },
});

export const { setConfiguration } = configSlice.actions;
export default configSlice.reducer;
